import React from 'react';
import { Navigate } from 'react-router-dom';

import { getLocalStorage } from '../utils/auth';

const ProtectedLoginRoute = ({ children }) => {
    const token = getLocalStorage('access');
    return token ? <Navigate to="/dashboard" /> : children;
};

export default ProtectedLoginRoute;